import { defineStore } from 'pinia';
import camelCase from 'lodash-es/camelCase'


export const useFeatureFlagStore = defineStore('feature-flag', () => {

  const featureFlags = {
    groupBooking1124: ref<boolean>(false),
  }

  function showFeature(featureFlag: string) {
    const flagKey = camelCase(featureFlag) as keyof typeof featureFlags;
    if (!featureFlags[flagKey]) return;
    featureFlags[flagKey].value = true;
  }


  return {
    showFeature,
    ...featureFlags
  }

})
